module.exports = __webpack_public_path__ + "static/media/banner.bfda8717.jpg";